/**
 * originBase reads an origin as the base a studio path is appended to: one trailing `/` is
 * dropped, so `https://example.com/`, the form `new URL(...).href` writes, and
 * `https://example.com` build the same URL.
 *
 * A leaf of its own, read by the embed snippet and the share link alike, so a module that builds
 * a share link loads none of the embed's configuration.
 *
 * @param origin - A scheme and a host, with or without one trailing `/`.
 * @returns The origin with no trailing `/`.
 */
export const originBase = (origin: string): string =>
  origin.endsWith("/") ? origin.slice(0, -1) : origin;
